import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actions } from 'store/newDocumentStore';
import DocumentLoader from 'routes/Documents/containers/DocumentLoaderContainer';
import DocumentProvider from 'routes/Documents/containers/DocumentProvider';

import Benefits from '../components/Benefits';

const BenefitsContainer = ({ edit, create }) => (
  <DocumentLoader names={['benefits']}>
    <DocumentProvider>
      <Benefits onStartEdit={edit} onCreate={create} />
    </DocumentProvider>
  </DocumentLoader>
);

BenefitsContainer.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
};

export default connect(null, { edit: actions.createCommit, create: actions.createDocumentAndCommit })(
  BenefitsContainer,
);
